'use client'

import textHeadingM from '@fukku/styles/texts/textHeadingM.module.css'
import textPromoTitleL from '@fukku/styles/texts/textPromoTitleL.module.css'
import styles from './HeroBannerSecondaryLinesTitles.module.css'

type HeroBannerSecondaryLinesTitlesProps = {
	readonly subTitle: string
	readonly title: string
	readonly isSingleCta: boolean
}

export function HeroBannerSecondaryLinesTitles({
	subTitle,
	title,
	isSingleCta,
}: HeroBannerSecondaryLinesTitlesProps): React.ReactNode {
	const titles = (
		<>
			<p className={textHeadingM.className}>{subTitle}</p>
			<div className={`${styles.title} ${textPromoTitleL.className}`}>
				{title}
			</div>
		</>
	)
	if (isSingleCta) {
		return <div className={styles.bannerTitles}>{titles}</div>
	}

	return <h2 className={styles.bannerTitles}>{titles}</h2>
}
